module.exports = __webpack_public_path__ + "img/pe.1c1780ee.svg";